import React, { useEffect, useState } from 'react'

import style from './style.module.scss'

interface IUseTimerProps {
  warn: number
  max: number
  onEnd?: () => void
}

const toMMSS = (time: number) => {
  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time - hours * 3600) / 60)
  const seconds = time - hours * 3600 - minutes * 60
  return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`
}

const Timer = ({ warn, max, onEnd }: IUseTimerProps) => {
  const [time, setTime] = useState(0)

  useEffect(() => {
    if (time >= max && 'function' == typeof onEnd) onEnd()

    const intervalId = setInterval(() => {
      setTime(time + 1)
    }, 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [time, max, onEnd])

  return <div className={`${time > warn ? style.warn : ''}`}>{toMMSS(time)}</div>
}

export default Timer
